import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlow, KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

export class GetKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext): Promise<KioskFlow | null> {
    assertOperator(ctx);
    return this.repository.getFlow(ctx);
  }
}
